import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver-es';
import { Beslut } from '../interfaces/beslut.interface';
import { IndividualB2LinkService } from './individual-b2-link.service';
import { HttpResponse } from '@angular/common/http';
import { SessionService } from '../session/session.service';

@Component({
    selector: 'individual-b2-link',
    template: `
  <button (click)="getFile()" class="btn nowrap-btn btn-link" title="B2 individuell"><fa-icon [icon]="['fas', 'file-pdf']" size="lg" class="me-2" [fixedWidth]="true" [style.color]="'#C0392B'"></fa-icon>{{ caption || ('label.ladda-ner' | translate) }}</button>`,
    styles: [`
  .btn.active.focus, .btn.active:focus, .btn.focus, .btn:active.focus, .btn:active:focus, .btn:focus {
     outline: 0;
     outline-offset: 0;
   }
   .btn-link {
     padding: 0;
   }`],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IndividualB2LinkComponent {
  @Input()
  public beslut: Beslut;
  @Input()
  public caption: string;

  constructor(
    protected service: IndividualB2LinkService,
    protected sessionService: SessionService,
    protected spinner: NgxSpinnerService) {
  }

  public getFile(): void {

    this.spinner.show();

    this.service.get(this.sessionService.activeInstance.id, this.beslut.id).subscribe(
      (response: HttpResponse<ArrayBuffer>) => {
        this.spinner.hide();
        const filename = response.headers.get('x-filename');
        const contentType = response.headers.get('content-type');
        const blob = new Blob([response.body], { type: contentType });
        saveAs(blob, filename);
      },
      (error) => {
        this.spinner.hide();
      });
  }

  //public getFile(): void {
  //  this.spinner.show();
  //  this.service.get(this.instanceService.instanceId, this.beslut.id).subscribe(
  //    (response: Tempfil) => {
  //      this.spinner.hide();

  //      try {
  //        const b64ToBlob = (b64Data: string, contentType: string = '', sliceSize: number = 512) => {
  //          const byteCharacters = atob(b64Data);
  //          const byteArrays: Uint8Array[] = [];

  //          for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
  //            const slice = byteCharacters.slice(offset, offset + sliceSize);

  //            const byteNumbers = new Array(slice.length);
  //            for (let i = 0; i < slice.length; i++) {
  //              byteNumbers[i] = slice.charCodeAt(i);
  //            }

  //            const byteArray = new Uint8Array(byteNumbers);
  //            byteArrays.push(byteArray);
  //          }

  //          const blob = new Blob(byteArrays, { type: contentType });
  //          return blob;
  //        }

  //        saveAs(b64ToBlob(response.data, 'application/pdf'), response.filnamn);
  //      } catch (e) {
  //        const downloadLink = document.createElement('a');
  //        downloadLink.href = `data:application/pdf;base64,${response.data}`;
  //        saveAs();
  //        downloadLink.download = response.filnamn;
  //        downloadLink.target = '_blank';

  //        document.body.appendChild(downloadLink);
  //        downloadLink.click();
  //        document.body.removeChild(downloadLink);
  //      }
  //    },
  //    (error) => {
  //      this.spinner.hide();
  //    });
  //}
}
